import type { ComponentPropsWithoutRef, ReactNode } from "react";
import styles from "./index.module.css";

export const IconButton = ({
  id,
  children,
  disabled,
  onClick,
  selected,
  hasBorder = true,
  variant = "white",
  ...rest
}: {
  id?: string;
  children: ReactNode;
  disabled?: boolean;
  selected?: boolean;
  onClick?: () => void;
  hasBorder?: boolean;
  variant?: "white" | "transparent" | "orange" | "transparent-grey";
} & ComponentPropsWithoutRef<"button">) => (
  <button
    className={styles.IconButton}
    id={id}
    disabled={disabled}
    onClick={onClick}
    type="button"
    data-selected={selected}
    data-border={hasBorder}
    data-variant={variant}
    {...rest}
  >
    {children}
  </button>
);
